import NotFoundSEO from '../components/seo/NotFoundSEO';
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import AIPageTemplate from '../components/seo/AIPageTemplate';
import { getPageBySlug } from '../data/geoContentDatabase';

/**
 * GEOPage - Dynamic page renderer for LLM/GEO optimized content
 * 
 * Renders AIPageTemplate with content from geoContentDatabase
 * based on marketplace and slug URL parameters
 */

const GEOPage = ({ marketplace }) => {
  const { slug } = useParams();
  
  // Get page content from database
  const pageContent = getPageBySlug(marketplace, slug);
  
  // Unknown slug: noindex 404 (Phase X.9 — no soft-404 redirects)
  if (!pageContent) {
    return <NotFoundSEO backTo={`/${marketplace}-seller-onboarding`} backLabel="Marketplace onboarding guide" />;
  }
  
  return (
    <AIPageTemplate
      slug={pageContent.slug}
      marketplace={pageContent.marketplace}
      title={pageContent.title}
      metaTitle={pageContent.metaTitle}
      metaDescription={pageContent.metaDescription}
      keywords={pageContent.keywords}
      directAnswer={pageContent.directAnswer}
      steps={pageContent.steps}
      stepsTitle={pageContent.stepsTitle}
      caseStudy={pageContent.caseStudy}
      mistakes={pageContent.mistakes}
      expertInsight={pageContent.expertInsight}
      faqs={pageContent.faqs}
      pillarPage={pageContent.pillarPage}
      relatedPages={pageContent.relatedPages}
      includeHowToSchema={pageContent.includeHowToSchema}
    />
  );
};

// Marketplace-specific page components
export const MyntraGEOPage = () => <GEOPage marketplace="myntra" />;
export const NykaaGEOPage = () => <GEOPage marketplace="nykaa" />;
export const AjioGEOPage = () => <GEOPage marketplace="ajio" />;

export default GEOPage;
